import {AccordionSettings} from '../../common/configuration'
import {Promotion} from '../../types/singleModelInterface'
import {findPromotionOpenByDefaultInShowroom} from './findPromotionOpenByDefaultInShowroom'

/**
 * Gets the id of the promotion open in a showroom list. Until the user opens or
 * closes a promotion, it is the one open by default in the showroom: being
 * computed while rendering, it is open as soon as the promotions are shown,
 * whenever the Feature App is loaded (e.g. lazily, once scrolled into view).
 *
 * @param promotions Promotions of the list, in the order shown on the page
 * @param userOpenPromotionId Promotion opened by the user,
 * `ACCORDION_INDEX_CLOSE_ALL_ITEMS` if they closed it, `null` until they
 * interact with the list
 * @returns The id of the open promotion, `ACCORDION_INDEX_CLOSE_ALL_ITEMS` if
 * none is open
 */
export function getShowroomOpenPromotionId(
    promotions: Promotion[] | undefined,
    userOpenPromotionId: number | null
): number {
    if (userOpenPromotionId !== null) {
        return userOpenPromotionId
    }

    return (
        findPromotionOpenByDefaultInShowroom(promotions)?.id ??
        AccordionSettings.ACCORDION_INDEX_CLOSE_ALL_ITEMS
    )
}
